import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
  Chip,
  Box,
  IconButton,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const STORAGE_KEY = 'dev_notice_dismissed';

const DEV_NOTICES = [
  {
    id: 'old-project-pages-v1',
    priority: 'medium',
    title: 'พิจารณาลบหน้าเก่า 2 หน้า',
    description:
      'ProjectDetail.js (route /project/project/detail/:id) และ EditProject.js (route /project/project/edit/:id) — มี ProjectPopup + ProjectEditPopup แทนแล้ว ต้องตัดสินใจว่าจะลบหรือเก็บเป็น fallback',
  },
];

const PRIORITY_COLOR = { high: 'error', medium: 'warning', low: 'default' };
const PRIORITY_LABEL = { high: 'สูง', medium: 'กลาง', low: 'ต่ำ' };

function getDismissed() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

export default function DevNoticePopup() {
  const [dismissed, setDismissed] = useState(getDismissed);
  const [branch, setBranch] = useState('');

  React.useEffect(() => {
    // Set initial branch
    function updateBranch() {
      if (window && window.__BRANCH_NAME__) {
        setBranch(window.__BRANCH_NAME__);
      } else {
        setBranch(process.env.REACT_APP_BRANCH || '');
      }
    }
    updateBranch();
    // Poll for branch changes every 2 seconds
    const interval = setInterval(updateBranch, 2000);
    return () => clearInterval(interval);
  }, []);

  const pending = DEV_NOTICES.filter((n) => !dismissed.includes(n.id));

  if (process.env.NODE_ENV !== 'development' || pending.length === 0) return null;

  function dismiss(id) {
    const next = [...dismissed, id];
    setDismissed(next);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  }

  function dismissAll() {
    const next = DEV_NOTICES.map((n) => n.id);
    setDismissed(next);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  }

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <WarningAmberIcon color="warning" />
          <Typography fontWeight={600} flex={1}>
            Dev — งานค้าง {pending.length} รายการ
            {branch && (
              <span style={{ color: '#fff', background: '#d32f2f', borderRadius: 4, padding: '2px 8px', marginLeft: 8, fontSize: 13 }}>
                {branch}
              </span>
            )}
          </Typography>
          <IconButton size="small" onClick={dismissAll}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Stack spacing={2}>
          {pending.map((notice) => (
            <Box
              key={notice.id}
              sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 1.5 }}
            >
              <Stack direction="row" alignItems="flex-start" spacing={1} mb={0.5}>
                <Chip
                  label={PRIORITY_LABEL[notice.priority]}
                  color={PRIORITY_COLOR[notice.priority]}
                  size="small"
                />
                <Typography fontWeight={600} fontSize={14} flex={1}>
                  {notice.title}
                </Typography>
                <IconButton size="small" onClick={() => dismiss(notice.id)}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Stack>
              <Typography fontSize={13} color="text.secondary" sx={{ pl: 0.5 }}>
                {notice.description}
              </Typography>
            </Box>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={dismissAll} color="inherit" size="small">
          ปิดทั้งหมด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
